import { useRoute } from 'vue-router';
import { onMounted, reactive } from 'vue';
import { getMusicListItem, getSongList } from '@/request/api/item.js';
import MusicListItemTop from '@/components/MusicListItem/MusicListItemTop.vue';
import MusicListItemList from '@/components/MusicListItem/MusicListItemList.vue';
export default {
  setup() {
    const state = reactive({
      itemPlayList: {},
      songList: []
    });
    onMounted(async () => {
      let id = useRoute().query.id;
      let {
        data: res
      } = await getMusicListItem(id);
      state.itemPlayList = res.playlist;
      let result = await getSongList(res.playlist.trackIds.map(item => Number(item.id)).join(','));
      state.songList = result.data.songs; // sessionStorage.setItem('itemDetail', JSON.stringify(state))
    });
    return {
      state
    };
  },

  components: {
    MusicListItemTop,
    MusicListItemList
  }
};